import { specialCea608CharsCodes } from './specialCea608CharsCodes.js';
export function getCharForByte(byte) {
    return String.fromCharCode(specialCea608CharsCodes[byte] || byte);
}
;
//# sourceMappingURL=getCharForByte.js.map